import useAuthSession from 'context/AuthContext';

const useLoggedIn = (): boolean => {
  return useAuthSession().isActive;
};

export default useLoggedIn;
